
export const audienceRoutes = [
  {
    path: '/audiences',
    meta: { title: 'Audiences' },
    name: 'Audiences',
    component: () => import('../views/audience/Index.vue')
  }
]
